import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getMember, updateMember } from '../../../api/members';
import { setMemberData } from '../../../store/memberSlice';
import { RootState } from '../../../store/store';
import './DisableNotificationToggle.scss';

const DisableNotificationToggle = () => {
  const dispatch = useDispatch();
  const { memberData } = useSelector((state: RootState) => state.member);
  const [isUpdating, setIsUpdating] = useState(false);

  if (!memberData?.user_id) {
    return null;
  }

  // true = disabled, false = enabled (default)
  const notificationsDisabled = memberData.notifications_disabled ?? false;

  const updateNotificationsDisabled = async (notifications_disabled: boolean) => {
    if (isUpdating || notifications_disabled === notificationsDisabled) {
      return;
    }

    setIsUpdating(true);

    try {
      await updateMember({
        user_id: memberData.user_id,
        notifications_disabled,
      });

      const updatedMember = await getMember(memberData.user_id);
      dispatch(setMemberData(updatedMember));

      toast.success(
        notifications_disabled
          ? 'Notifications disable for member'
          : 'Notifications enable for member'
      );
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.description ||
        'Failed to update notification setting';
      toast.error(errorMessage);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className='disable-notification-row'>
      <span className='disable-notification-label'>Disable Notification</span>
      <div className='disable-notification-toggle' role='group' aria-label='Disable Notification'>
        <button
          type='button'
          className={`toggle-option toggle-disabled ${notificationsDisabled ? 'active' : ''}`}
          onClick={() => updateNotificationsDisabled(true)}
          disabled={isUpdating}
          aria-label='Disable'
          aria-pressed={notificationsDisabled}
          data-tooltip='Disable'
        >
          ✓
        </button>
        <button
          type='button'
          className={`toggle-option toggle-enabled ${!notificationsDisabled ? 'active' : ''}`}
          onClick={() => updateNotificationsDisabled(false)}
          disabled={isUpdating}
          aria-label='Enable'
          aria-pressed={!notificationsDisabled}
          data-tooltip='Enable'
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default DisableNotificationToggle;
